import React from "react";
import { DesktopIcon, MobileIcon, TabletIcon } from "../Icons/ScreenSizeIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";




export default function SizePreviewMenu({currentPreviewState,onChange}:{currentPreviewState:ScreenSize,onChange:(newState:ScreenSize)=>void}){


  

    return (

        <div className="preview-option-row center-all">
          
            <button className ={"desktop preview-option center-all invisible-button "+(currentPreviewState==ScreenSize.Desktop?"selected":"")}   onClick={()=>onChange(ScreenSize.Desktop)} ><DesktopIcon/></button>
            <button className ={"tablet preview-option center-all invisible-button "+(currentPreviewState==ScreenSize.Tablet?"selected":"")}     onClick={()=>onChange(ScreenSize.Tablet)} ><TabletIcon/></button>
            <button className ={"mobile preview-option center-all invisible-button "+(currentPreviewState==ScreenSize.Mobile?"selected":"")}     onClick={()=>onChange(ScreenSize.Mobile)} ><MobileIcon/></button>
        </div>
    )


}

// function LayoutIcon(){

//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill = "#333">
// <path d="M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"/></svg>
// }

